import Abstract from './abstract';
import { onSendGTag } from './module';

const INITIAL_STATE = {
  isPopupOpen: false
}

const onSendMediumLogoGTag = (e) => {
  const mediumName = e.currentTarget.dataset.gaArticleMediumName;

  onSendGTag('タップ', {
    event_category: 'メディアロゴ',
    event_label: mediumName
  });
};

const onSendReadMoreContinueGTag = () => {
  onSendGTag('タップ', {
    event_category: '続きを読む',
    event_label: 'タップ',
    non_interaction: true
  });
};

const onSendClickRewardPopupGTag = () => {
  onSendGTag('タップ', {
    event_category: '記事リワード_ポップアップ表示',
    event_label: 'タップ',
    non_interaction: true
  });
};

const onSendClickRewardReadMoreGTag = () => {
  onSendGTag('タップ', {
    event_category: '続きを読む_リワード広告表示',
    event_label: 'タップ',
    non_interaction: true
  });
};

const onSendOriginalLinkGTag = (e) => {
  const link = e.currentTarget.getAttribute('href');

  onSendGTag('タップ', {
    event_category: '元記事を読む',
    event_label: 'タップ',
    link_url: link
  });
};

const onSendPVBoostLinkGTag = (e) => {
  const link = e.currentTarget.getAttribute('href');

  onSendGTag('タップ', {
    event_category: 'スポコン救済枠',
    event_label: 'タップ',
    link_url: link
  });
};

const onSendNextArticleLinkGTag = (e) => {
  const link = e.currentTarget.getAttribute('href');

  onSendGTag('タップ', {
    event_category: '次の記事',
    event_label: 'タップ',
    link_url: link
  });
};

const onSendMediumRelatedArticleLinkGTag = (e) => {
  const title = e.currentTarget.dataset.gaMediumRelatedArticleTitle;
  const link = e.currentTarget.getAttribute('href');

  onSendGTag('タップ', {
    event_category: 'メディア関連記事枠',
    event_label: title,
    link_url: link
  });
};

const onSendrankingLinksGTag = (e) => {
  const link = e.currentTarget.getAttribute('href');

  onSendGTag('タップ', {
    event_category: 'ランキング',
    event_label: 'タップ',
    link_url: link
  });
};
const onSendRelatedArticleLinkGTag = (e) => {
  const title = e.currentTarget.dataset.gaRelatedArticleTitle;
  const link = e.currentTarget.getAttribute('href');

  onSendGTag('タップ', {
    event_category: 'あなたにおすすめの記事',
    event_label: title,
    link_url: link
  });
};

export default class ArticleDetailView extends Abstract {
  init() {
    this.getElement();

    this.addEvent();

    this.addGAM();
  }

  initState() {
    this.state = Object.assign({}, INITIAL_STATE);
  }

  getElement() {
    this.header = document.querySelector('.js-global-header');
    this.headerBar = this.header.querySelector('.js-headerBar');
    this.headerOverlay = document.querySelector('.js-header-overlay-ads');
    this.headerW2A = document.querySelector('.js-articles-w2a-banner');
    this.wrapper = document.querySelector('.js-wrapper');

    this.descriptionOuter = document.querySelector('.js-article-description-outer');
    this.readMoreOuter = document.querySelector('.js-article-readmore-outer');
    this.readMoreButton = document.querySelector('.js-article-readmore-button');

    this.rewardReadMoreButton = document.querySelector('.js-article-reward-readmore-button');
    this.rewardStartButton = document.querySelector('.js-articles-reward-start-button');
    this.popup = document.querySelector('.articleDetail-Popup');

    this.pvboostLink = Array.prototype.slice.call(document.querySelectorAll('.js-article-pvboost-link'));

    this.nextArticleLink = document.querySelector('.js-next-article-link');

    this.mediumLogo = document.querySelector('.js-article-medium-logo-link');
    this.originalLink = document.querySelector('.js-article-original-link');
    this.relatedMediumArticleLinks = Array.prototype.slice.call(document.querySelectorAll('.js-medium-related-article-link'));

    this.rankingLinks = document.querySelectorAll('.js-article-detail-ranking-link');

    this.relatedArticleLinks = Array.prototype.slice.call(document.querySelectorAll('.js-related-article-link'));

    this.ArticleDetailContainer = document.querySelector('.js-article-detail-container');
  }

  addEvent() {
    if (this.descriptionOuter && this.readMoreButton) this.readMoreButton.addEventListener('click', this.onClick.bind(this));
    if (this.descriptionOuter && this.rewardReadMoreButton) this.rewardReadMoreButton.addEventListener('click', this.onPopupClick.bind(this));

    if (this.rewardStartButton) this.rewardStartButton.addEventListener('click', this.onRewardClick.bind(this));

    if (this.pvboostLink) {
      this.pvboostLink.forEach((el) => {
        el.addEventListener('click', onSendPVBoostLinkGTag);
      });
    }

    if (this.originalLink) this.originalLink.addEventListener('click', onSendOriginalLinkGTag);

    if (this.nextArticleLink) this.nextArticleLink.addEventListener('click', onSendNextArticleLinkGTag);

    if (this.relatedMediumArticleLinks) {
      this.relatedMediumArticleLinks.forEach((el) => {
        el.addEventListener('click', onSendMediumRelatedArticleLinkGTag);
      });
    }

    if (this.rankingLinks) {
      this.rankingLinks.forEach((el, index) => {
        el.addEventListener('click', (e) => {
          const indexNumber = index + 1;
          onSendrankingLinksGTag(e, indexNumber);
        });
      });
    }

    this.mediumLogo.addEventListener('click', onSendMediumLogoGTag);

    if (this.relatedArticleLinks) {
      this.relatedArticleLinks.forEach((el) => {
        el.addEventListener('click', onSendRelatedArticleLinkGTag);
      });
    }
  }

  getPosition() {
    this.headerBarPosition = this.headerBar.getBoundingClientRect();
    this.headerOverlayPosition = this.headerOverlay ? this.headerOverlay.getBoundingClientRect() : 0;
    this.headerW2APosition = this.headerW2A ? this.headerW2A.getBoundingClientRect() : 0;
  }

  onClick() {
    this.removeReadMore();

    onSendReadMoreContinueGTag();
  }

  removeReadMore() {
    this.descriptionOuter.classList.remove('articleDetail-MainContent_Body-hidden');

    this.readMoreOuter.remove();

    window.dispatcher.emit('READ_MORE_ARTICLE');

    this.addW2ABanner();
  }

  onPopupClick() {
    if (!this.state.isPopupOpen) {
      onSendClickRewardPopupGTag();
      this.onUpdateState({
        isPopupOpen: true
      });
    } else {
      this.onUpdateState({
        isPopupOpen: false
      });
    }

    if (this.popup) {
      this.popup.classList.toggle('articleDetail-Popup_isShow');
    }
  }

  onRewardClick() {
    onSendClickRewardReadMoreGTag();
    this.rewardAd();
  }

  addW2ABanner() {
    this.headerW2A.style.display = 'block';

    this.getPosition();

    const headerOverlayHeight =
      this.headerOverlayPosition.height > 100 ?
      this.headerOverlayPosition.height : (this.headerBarPosition.top > 0 ? 100 : 0);

    this.headerW2A.style.top = `${headerOverlayHeight}px`;
    this.header.style.top = `${this.headerW2APosition.height + headerOverlayHeight}px`;
    this.wrapper.style.marginTop =
      this.headerOverlayPosition.height > 100 ? `${this.headerW2APosition.height + headerOverlayHeight}px` : `${this.headerBarPosition.height}px`;

  }

  addGAM() {
    if (this.ArticleDetailContainer) {
      const target2DomH3 = this.ArticleDetailContainer.getElementsByTagName('h3')[1];
      const target4DomH4 = this.ArticleDetailContainer.getElementsByTagName('h4')[3];
      const target4DomH5 = this.ArticleDetailContainer.getElementsByTagName('h5')[3];
      const target3DomH4 = this.ArticleDetailContainer.getElementsByTagName('h4')[2];
      const target10DomP = this.ArticleDetailContainer.getElementsByTagName('p')[9];
      const target5DomFigure = this.ArticleDetailContainer.getElementsByTagName('figure')[4];
      const target7DomP = this.ArticleDetailContainer.getElementsByTagName('p')[6];
      const target5DomP = this.ArticleDetailContainer.getElementsByTagName('p')[4];
      const target4DomFigure = this.ArticleDetailContainer.getElementsByTagName('figure')[3];
      const target3DomP = this.ArticleDetailContainer.getElementsByTagName('p')[2];
      const target2DomP = this.ArticleDetailContainer.getElementsByTagName('p')[1];

      const gam = `<div id="div-gpt-ad-1622988823590-0"></div>`;

      if (target2DomH3) {
        target2DomH3.insertAdjacentHTML('beforebegin', gam);
      } else if (target4DomH4) {
        target4DomH4.insertAdjacentHTML('beforebegin', gam);
      } else if (target4DomH5) {
        target4DomH5.insertAdjacentHTML('beforebegin', gam);
      } else if (target3DomH4) {
        target3DomH4.insertAdjacentHTML('beforebegin', gam);
      } else if (target10DomP) {
        target10DomP.insertAdjacentHTML('beforebegin', gam);
      } else if (target5DomFigure) {
        target5DomFigure.insertAdjacentHTML('beforebegin', gam);
      } else if (target7DomP) {
        target7DomP.insertAdjacentHTML('beforebegin', gam);
      } else if (target5DomP) {
        target5DomP.insertAdjacentHTML('beforebegin', gam);
      } else if (target4DomFigure) {
        target4DomFigure.insertAdjacentHTML('beforebegin', gam);
      } else if (target3DomP) {
        target3DomP.insertAdjacentHTML('beforebegin', gam);
      } else if (target2DomP) {
        target2DomP.insertAdjacentHTML('beforebegin', gam);
      }
    }
  }

  rewardAd() {
    const removeRewardReadMore = () => {
      this.removeReadMore();
    };
    googletag = window.googletag || {cmd: []};
    googletag.cmd.push(() => {
      const rewardedSlot = googletag.defineOutOfPageSlot(
        '/21763395206/comic/comic_SP_web_reward',
        googletag.enums.OutOfPageFormat.REWARDED)
        .addService(googletag.pubads());
        googletag.pubads().enableAsyncRendering();
        googletag.enableServices();

      var grantedFlag = false;

      googletag.pubads().addEventListener('slotRenderEnded', function(event) {
        if (event.isEmpty) {
          removeRewardReadMore();
        }
      });
      googletag.pubads().addEventListener('rewardedSlotReady', function(event) {
        event.makeRewardedVisible();
      });
      googletag.pubads().addEventListener('rewardedSlotGranted', function() {
        grantedFlag = true;
        removeRewardReadMore();
      });
      googletag.pubads().addEventListener('rewardedSlotClosed', function() {
        googletag.destroySlots([rewardedSlot]);
        if (!grantedFlag) {
          window.location.replace(location.pathname + '?ArticleReferrer=reward');
        }
      });
      googletag.display(rewardedSlot);
      googletag.pubads().refresh([rewardedSlot]);
    });
  }
}
